import React from 'react';
import { motion } from 'framer-motion';
import { FiBox, FiAlertCircle, FiRefreshCcw, FiArrowUp } from 'react-icons/fi';

const inventoryItems = [
  { id: 1, item: 'Organic Coffee Beans', sku: 'CF-ORG-001', stock: 1200, unit: 'kg', level: 85, status: 'Healthy' },
  { id: 2, item: 'Milk Alternative (Almond)', sku: 'MK-ALM-050', stock: 45, unit: 'ltr', level: 12, status: 'Critical' },
  { id: 3, item: 'Sugar Packets', sku: 'SG-PCK-100', stock: 5000, unit: 'pcs', level: 95, status: 'Healthy' },
  { id: 4, item: 'Paper Cups (12oz)', sku: 'CP-PAP-012', stock: 350, unit: 'pcs', level: 25, status: 'Low' },
];

const Inventory = () => {
  return (
    <div className="container-fluid p-0">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="fw-bold mb-1">Global Inventory</h2>
          <p className="text-muted small mb-0">Real-time stock tracking and supply chain optimization.</p>
        </div>
        <div className="d-flex gap-2">
          <button className="btn glass-card border-0 text-white px-3 d-flex align-items-center gap-2"><FiRefreshCcw /> Sync All</button>
          <button className="btn btn-primary px-3">Restock Order</button>
        </div>
      </div>

      <div className="row g-4 mb-4">
        <div className="col-md-4">
          <div className="glass-card p-4 border-start border-primary border-4">
            <h6 className="text-muted small uppercase fw-bold mb-3">Total SKUs</h6>
            <h2 className="fw-bold mb-0">1,240</h2>
          </div>
        </div>
        <div className="col-md-4">
          <div className="glass-card p-4 border-start border-danger border-4">
            <h6 className="text-muted small uppercase fw-bold mb-3">Low Stock Alerts</h6>
            <h2 className="fw-bold mb-0 text-danger">14</h2>
          </div>
        </div>
        <div className="col-md-4">
          <div className="glass-card p-4 border-start border-success border-4">
            <h6 className="text-muted small uppercase fw-bold mb-3">Incoming Shipments</h6>
            <h2 className="fw-bold mb-0 text-success">6</h2>
          </div>
        </div>
      </div>

      <div className="glass-card p-4">
        <div className="table-responsive">
          <table className="table table-dark table-hover mb-0 border-0">
            <thead>
              <tr className="text-muted small uppercase">
                <th className="border-0">Item Name</th>
                <th className="border-0">SKU</th>
                <th className="border-0">Current Stock</th>
                <th className="border-0">Stock Level</th>
                <th className="border-0">Status</th>
                <th className="border-0 text-end">Action</th>
              </tr>
            </thead>
            <tbody>
              {inventoryItems.map((item) => (
                <tr key={item.id} className="align-middle">
                  <td className="border-0 py-4 fw-bold">{item.item}</td>
                  <td className="border-0 py-4 small text-muted">{item.sku}</td>
                  <td className="border-0 py-4">{item.stock} {item.unit}</td>
                  <td className="border-0 py-4" style={{ width: '200px' }}>
                    <div className="progress bg-dark bg-opacity-50" style={{ height: '6px' }}>
                      <div 
                        className={`progress-bar bg-${item.level < 30 ? 'danger' : item.level < 60 ? 'warning' : 'primary'}`} 
                        style={{ width: `${item.level}%` }}
                      ></div>
                    </div>
                  </td>
                  <td className="border-0 py-4">
                    <span className={`badge bg-${item.status === 'Healthy' ? 'success' : item.status === 'Low' ? 'warning' : 'danger'} bg-opacity-10 text-${item.status === 'Healthy' ? 'success' : item.status === 'Low' ? 'warning' : 'danger'}`}>
                      {item.status}
                    </span>
                  </td>
                  <td className="border-0 py-4 text-end">
                    <button className="btn btn-sm btn-link text-primary text-decoration-none fw-bold">Update</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Inventory;
